module.exports = __webpack_public_path__ + "img/shop_area_2.1f0d737e.jpg";